export default __webpack_public_path__ + "static/one-click-seg-e410af15a3bdbf133c0f175f69c7448d.gif";